import { ChoiceOption } from 'ui/types'

export type CrbMonitorListPayload = {
  allRelationships: boolean
  connectionStatus: string | null
  crbLicenseStatus: string
  licenseId: number
  onlyAlerted: boolean
  assignedRelationshipsOnly: boolean
  page: number
  relationshipId: number | string
  searchTerm: string
  size: number
  sortBy: string
  sortDesc: boolean
  customerStatus: string
}

export type CRBConnections = {
  connectionStatus: string
  disconnected: boolean
  id: number
  showLicenseAlerted?: string
  licenseId: number
  licenseName: string
  licenseNumber: string
  relationship: string
  relationshipId: number
  showConnectedAt: string
  showExternalStatus: string
  showExternalStatusMark: CRBLicenseStatus
  showLastCheckedAt: string
  crbmLicenseStatus: unknown
}

export type CrbMonitorListResponse = {
  connectionStatusOptions: ChoiceOption[]
  connections: CRBConnections[]
  crbLicenseStatusOptions: ChoiceOption[]
  form: {
    allRelationships: boolean
    connectionStatus: string
    crbLicenseStatus: string
    licenseId: number
    onlyAlerted: boolean
    page: number
    relationshipId: number
    searchTerm: string
    size: number
    sortDesc: boolean
    sortBy: string
    customerStatus: string
  }
  licensesOptions: ChoiceOption[]
  relationshipOptions: ChoiceOption[]
  customerStatusOptions: ChoiceOption[]
  totalCount: number
}

export type CRBLicensesList = {
  form: {
    licenseId: number
    query: string
  }
  licenses: CRBLicenses[]
  showHintType: CRBIdLicenseHintType
  showHintMessage: string
  totalCount: number
}

export type CRBLicenses = {
  addresses: CRBAddress[]
  businesses: string
  expiryDate: string
  id: number
  isSelected: boolean
  issuedDate: string
  licenseIdentifier: string
  licensee: string
  licensingAuthorityName: string
  locality: string
  medRecClassification: string
  reportedStatus: string
  reportedTypeDescription: string
  showConnectionStatusChangedAt: string
  showPreviousStatus: string
  showStatusLastCheckedAt: string
  status: string
  statusDate: string
  statusTag: CRBLicenseStatus
  uniformTypeDescription: string
}

export type CRBLicenseStatus = 'warning' | 'waiting' | 'active' | 'inactive' | 'suspended'

export type CRBAddress = {
  box: string
  building?: string
  city: string
  country: string
  county: string
  postalCode: string
  roomOrSuite: string
  state: string
  street: string
}

export enum CRBIdLicenseHintType {
  WARNING = 'warning',
  SUCCESS = 'success',
  DANGER = 'danger'
}

export type CRBIdLicenseDetails = {
  addresses: CRBAddress[]
  businesses: string
  connectedAt: string
  crbmId: number
  licenseIdentifier: string
  licensee: string
  licensingAuthorityName: string
  locality: string
  medRecClassification: string
  previousStatus: string
  reportedStatus: string
  reportedTypeDescription: string
  showHintMessage: string
  showHintType: CRBIdLicenseHintType
  status: string
  statusDate: Date
  statusLastCheckedAt: Date
  statusMark: 'ok' | 'warning'
  uniformTypeDescription: string
}
